/* eslint-disable no-unused-vars, max-len */
// CONSTANTS are all caps.
const NS = 'ArticleList';
const CLS = 'articleList';
const WG = '.' + CLS + '-';

// Import stuff here if you need to or even better to import them dynamically
// eslint-disable-next-line max-len
// for ex. of dynamic import check out src/scripts/loadWg/articleList.js using Webpack dynamic imports as chunks.
// import $ from 'jquery'


export class ArticleList {
	constructor($el) {
		// $el is the widget node return by the loadArticleList function
		this.$el = $el;
	}

	init() {
		this.setArticleList();
	}

	setArticleList() {
		// Add Some logic here
		let $wg = $(this.$el);

		if ($wg.hasClass(`${CLS}--showAll`)) {
			let $loadMoreForm = $wg.find('form');
			let $loadBtn = $loadMoreForm.find('[type="submit"]');
			let $items = $wg.find('.articleListItem');
			let itemsCount = $items.length;
			let skipCount = parseInt($loadMoreForm.find('[name="SearchFilter.LoadSkip"]').val()) || 4;

			// no form submit
			$loadBtn.attr('type', 'button');

			$items.each((index, element) => {
				$(element).data('index', index);

				if (index+1 > skipCount) {
					$(element).parent().addClass('d-none');
				}
			});

			if (itemsCount <= skipCount) {
				$loadBtn.addClass('d-none');
			}

			$loadBtn.on('click', () => {
				let visibleItemsCount = $wg.find('.articleListItem:visible').length;

				if (visibleItemsCount < itemsCount) {
					let startPos = $wg.find('.articleListItem:visible').last().data('index') + 1;
					let endPos = startPos + skipCount;
					for (let i = startPos; i < endPos; i++) {
						$items.eq(i).parent().removeClass('d-none');

						if ($wg.find('.articleListItem:visible').last().data('index') + 1 === $items.length) {
							$loadBtn.addClass('d-none');
						}
					}

					setTimeout(() => {
						$('html, body').animate({
							scrollTop: $items.eq(startPos).offset().top,
						}, 500);
					}, 250);
				} else {
					$loadBtn.addClass('d-none');
				}
			});
		}
	}

	// Add more functions like on above here
}
